import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppLayout from "./Layout/Layout";

import Login from "./Pages/Authentication/Login/Login";
import ErrorPage from "./Components/ErrorPage/Error404"; // your error page component
import { getClientConfig } from "./config/clientConfig";
import { useEffect } from "react";
import appConfig from "../src/config/client.json";
import AppRoutes from "./AppRoutes/AppRoutes";
import { Provider } from "react-redux";
import store from "./store";
import { UnsavedChangesGuardProvider } from "./Components/StatementViewer/UnsavedChangesGuard";

function App() {
  const clientConfig = getClientConfig();
  useEffect(() => {
    const data = clientConfig.titlebar;
    document.title = data.title;

    // Set favicon
    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      favicon.setAttribute("href", data.logo);
    }
  }, [clientConfig]);
  return (
    <div className="App">
      <Provider store={store}>
        <Router>
          {/* <AppLayout clientConfig={clientConfig} /> */}
          <UnsavedChangesGuardProvider>
            <AppRoutes />
          </UnsavedChangesGuardProvider>
        </Router>
      </Provider>
    </div>
  );
}

export default App;
